module.exports = __webpack_public_path__ + "img/section-03.9b541a8d.png";